import React from 'react'

const QuestionIcon = () => {
	return (
		<svg width={30} height={30} viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle cx={15} cy={15} r={14.5} stroke='currentColor' />
			<path
				d='M13.241 19.332c.014-.852.111-1.525.29-2.019.179-.494.544-1.042 1.096-1.644l1.407-1.45c.602-.68.902-1.41.902-2.191 0-.752-.197-1.34-.59-1.762-.394-.43-.967-.644-1.72-.644-.73 0-1.317.193-1.761.58-.444.386-.666.906-.666 1.557h-1.987c.014-1.16.426-2.094 1.235-2.803.816-.717 1.876-1.075 3.18-1.075 1.353 0 2.406.366 3.158 1.096.759.723 1.139 1.719 1.139 2.986 0 1.254-.58 2.489-1.74 3.706l-1.172 1.16c-.522.58-.784 1.415-.784 2.503h-1.987zm-.086 3.406c0-.322.097-.591.29-.806.2-.222.494-.333.88-.333.388 0 .681.111.882.333.2.215.3.484.3.806 0 .322-.1.59-.3.806-.2.207-.494.311-.881.311s-.68-.104-.88-.311a1.16 1.16 0 01-.291-.806z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default QuestionIcon
